import { Injectable, TemplateRef } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ToastService {
  toasts: any[] = [];

  // Push new Toasts to array with content and options
  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    const toast = { textOrTpl, ...options };
    this.toasts.push(toast);

    // Auto-hide toast after delay
    if (options.autohide !== false) {
      const delay = options.delay || 5000;
      setTimeout(() => {
        this.remove(toast);
      }, delay);
    }
  }

  // Callback method to remove Toast DOM element from view
  remove(toast) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  // Clear all toasts
  clear() {
    this.toasts = [];
  }

  // Convenience methods
  success(message: string) {
    this.show(message, { classname: "bg-success text-light", delay: 5000 });
  }

  error(message: string) {
    this.show(message, { classname: "bg-danger text-light", delay: 5000 });
  }

  warning(message: string) {
    this.show(message, { classname: "bg-warning text-dark", delay: 5000 });
  }

  info(message: string) {
    this.show(message, { classname: "bg-info text-light", delay: 5000 });
  }
}
